import { LegalPage } from '../components/landing/LegalPage';
import { termsOfService } from '../legal/documents';

export function Terms() {
  return <LegalPage source={termsOfService} />;
}
